import { Button, Checkbox, Col, Form, Input, Row, Select } from "antd";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Header from "../../components/Layout/Header";
import { ImageUrl } from "../../config/helper";

const ForgotPassword3 = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    try {
      navigate("/signIn");
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <Header />
      <Row
        justify="center"
        style={{
          backgroundImage: `url('${ImageUrl("register-back.png")}')`, // Setting background color to black with 90% opacity
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
        className="flex items-center justify-center min-h-screen"
      >
        <Col
          lg={8}
          md={18}
          xs={22}
          className="flex flex-col justify-center my-52 max-sm:my-32"
        >
          <div className="flex flex-col justify-center items-center bg-white rounded-lg py-8 px-8 max-lg:px-2 ">
            <h3 className="mt-4 font-tavi text-3xl text-black max-md:text-xl">
              Forgot Password
            </h3>
            <p className="capitalize font-euclid text-sm text-[#34324B] mb-8 max-md:text-xs text-center">
              Set your new password
            </p>
            <Form
              form={form}
              name="normal_login"
              onFinish={onFinish}
              layout="vertical"
              className="w-full px-8 max-xl:px-2"
            >
              <Row justify="center">
                <Col md={24} sm={24} xs={24}>
                  <Form.Item
                    name="password"
                    label={
                      <p className="font-euclid text-sm text-[#34324B] font-bold">
                        New Password
                      </p>
                    }
                    rules={[
                      {
                        required: true,
                        message: "Please input password!",
                      },
                    ]}
                  >
                    <Input.Password
                      placeholder="Enter New Password"
                      className="h-12 text-sm font-euclid bg-gray-100 "
                      autoComplete={false}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row justify="center">
                <Col md={24} sm={24} xs={24}>
                  <Form.Item
                    name="confirmPassword"
                    label={
                      <p className="font-euclid text-sm text-[#34324B] font-bold">
                        Confirm Password
                      </p>
                    }
                    rules={[
                      {
                        required: true,
                        message: "Please input password!",
                      },
                    ]}
                  >
                    <Input.Password
                      placeholder="Confirm Password"
                      className="h-12 text-sm font-euclid bg-gray-100 "
                      autoComplete={false}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row justify="center">
                <Col md={12}>
                  <Form.Item className="self-center text-center">
                    <Button
                      htmlType="submit"
                      className="bg-button hover:bg-white hover:border-customGold hover:border-2 font-urban font-bold text-white px-14 h-[50px] hover:text-customGold text-center text-sm"
                    >
                      {loading ? "LOADING..." : "UPDATE"}
                    </Button>
                  </Form.Item>
                </Col>
              </Row>

              <Row justify="center">
                <Link
                  to="/signIn"
                  className="font-euclid text-black text-sm border-b-2 border-black font-semibold mt-8 hover:text-black"
                >
                  Back to Sign In
                </Link>
              </Row>
            </Form>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default ForgotPassword3;
